import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { ObservableRequestService } from 'app/services/observable-request.service';
import { ConstantsService } from 'app/services/constants-service';

/**
 * Single normalized alert row, surfaced by `GET /monitoring/alerts`.
 *
 * `alertId` is a stable prefixed string the SPA uses for routing
 * (`sanctions:<entityId>:<sanctionEntityId>`, `pep:<entityId>:<pepEntityId>`, etc.).
 */
export interface AlertRow {
    alertId: string;
    product: 'sanctions' | 'pep' | 'negative_news' | 'leak_papers';
    entityId: number;
    entityName: string;
    summary?: string;
    listSource?: string;
    processed?: boolean;
    matchResolution?: string;
    hitDetectedAt?: number;
    screeningEntityId?: string;
    sanctionEntityId?: string;
    pepEntityId?: number;
    badPressEntityId?: number;
    comments?: string;
    matchBand?: string;
    matchScore?: number;
    payloadJson?: string;
}

export interface AlertListResponse {
    alerts: AlertRow[];
    total: number;
    statusFilter?: string;
    productFilter?: string[];
}

@Injectable()
export class AlertsService {
    constructor(private requestService: ObservableRequestService) { }

    listAlerts(products?: string[], status: string = 'OPEN', limit: number = 200): Observable<any> {
        const parts: string[] = [];
        if (products && products.length > 0) {
            parts.push('product=' + encodeURIComponent(products.join(',')));
        }
        parts.push('status=' + encodeURIComponent(status));
        parts.push('limit=' + limit);
        const qs = parts.length > 0 ? '?' + parts.join('&') : '';
        return this.requestService.getRequest(ConstantsService.MONITORING_ALERTS + qs);
    }

    getAlertDetail(alertId: string): Observable<any> {
        return this.requestService.getRequest(
            ConstantsService.MONITORING_ALERTS + '/' + encodeURIComponent(alertId));
    }

    deleteAllHits(entityId: number): Observable<any> {
        const uri = ConstantsService.MONITORING_DELETE_ALL_HITS + entityId;
        return this.requestService.deleteRequest(uri, {}, this.requestService.getJSONContentType());
    }
}



// WEBPACK FOOTER //
// ./src/app/alerts/alerts.service.ts